export const PUBLIC_TOOLS = [
  "sustainability-impact",
  "diversion-savings",
  "pickup-frequency",
  "gaylord-volume",
  "pallet-roi",
  "truck-loading",
  "freight-calculator",
  "price-check",
  "grade",
] as const;

export type PublicTool = (typeof PUBLIC_TOOLS)[number];

export const TOOL_USAGE_STEPS = [
  "started",
  "computed",
  "reported",
  "email_submitted",
  "confirmed",
  "cta_clicked",
] as const;

export type ToolUsageStep = (typeof TOOL_USAGE_STEPS)[number];
